import { useRef, useState } from 'react'

import { PosTaxInvoice } from '@/components/pos/PosTaxInvoice'
import { PosThermalReceipt } from '@/components/pos/PosThermalReceipt'

/**
 * Hidden hosts for thermal receipt and tax invoice printing.
 *
 * @param {object} props
 * @param {import('@/types/api').PosReceipt | null} props.receipt
 * @param {import('@/types/api').PosTaxInvoice | null} props.taxInvoice
 * @param {import('react').RefObject<HTMLDivElement | null>} props.receiptRootRef
 * @param {import('react').RefObject<HTMLDivElement | null>} props.taxInvoiceRootRef
 */
export function SaleDocumentPrintHosts({
  receipt,
  taxInvoice,
  receiptRootRef,
  taxInvoiceRootRef,
}) {
  return (
    <>
      <div ref={receiptRootRef}>
        <PosThermalReceipt receipt={receipt} />
      </div>
      <div ref={taxInvoiceRootRef}>
        <PosTaxInvoice invoice={taxInvoice} />
      </div>
    </>
  )
}

/**
 * @returns {{
 *   receiptRootRef: import('react').RefObject<HTMLDivElement | null>
 *   taxInvoiceRootRef: import('react').RefObject<HTMLDivElement | null>
 *   receipt: import('@/types/api').PosReceipt | null
 *   taxInvoice: import('@/types/api').PosTaxInvoice | null
 *   setReceipt: (value: import('@/types/api').PosReceipt | null) => void
 *   setTaxInvoice: (value: import('@/types/api').PosTaxInvoice | null) => void
 * }}
 */
export function useSaleDocumentPrintRefs() {
  const receiptRootRef = useRef(null)
  const taxInvoiceRootRef = useRef(null)
  const [receipt, setReceipt] = useState(null)
  const [taxInvoice, setTaxInvoice] = useState(null)

  return {
    receiptRootRef,
    taxInvoiceRootRef,
    receipt,
    taxInvoice,
    setReceipt,
    setTaxInvoice,
  }
}
